// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

 


import { CallAdapterState } from "@azure/communication-react";
import { useSelectorWithAdaptation } from "./useAdaptedSelector";

/**
 * @private
 */
const useSelector = <SelectorT extends (state: CallAdapterState, props: any) => any>(
    selector: SelectorT,
    selectorProps?: Parameters<SelectorT>[1]
): ReturnType<SelectorT> =>
    // use selector with no adaptation
     useSelectorWithAdaptation(selector, (state) => state, selectorProps)
;

// alias to avoid confusion with react-redux useSelector
export const useCallAdapterSelector = useSelector;
